import withErrorCheck from "../CheckError";
import server from "../Server";
import type { ICompetitionView } from "@grassrootly/api/entities";

// Fetch all competitions from official organizations
export const GetOfficialCompetitions = async (): Promise<ICompetitionView[]> => {
  const response = await server
    .from("Competitions")
    .select(`
      id,
      name,
      organization_id,
      created_at,
      team_size,
      Organizations!inner (
        name,
        logo,
        is_official
      )
    `)
    .eq("Organizations.is_official", true)
    .order("name", { ascending: true });

  const data = withErrorCheck<any[]>(response as any) || [];
  
  // Transform the nested structure to flat ICompetitionView
  return data.map((item) => ({
    id: item.id,
    name: item.name,
    organization_id: item.organization_id,
    created_at: item.created_at,
    team_size: item.team_size,
    organization_name: item.Organizations.name,
    organization_logo: item.Organizations.logo,
    is_official: item.Organizations.is_official,
  }));
};
